import administracion from "./Administracion/administracion"
import firmas from "./Firmas/firmas"
import caja from "./Caja/caja"
import consultas from "./Consultas/consultas"
import mensajes from "./Mensajes/mensajes"
import reportes from "./Reportes/reportes"
import verificacion from "./Verificacion/verificacion"

const sivac = {
  administracion: administracion,  
  firmas: firmas,
  caja: caja,
  consultas: consultas,
  mensajes: mensajes,
  reportes: reportes,
  verificacion: verificacion

}

export default sivac


//////////////////
// WEBPACK FOOTER
// ./static/js/api/SIVAC/Sistema/sistemaSIVAC.js
// module id = null
// module chunks = 